import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchCryptoWallets, fetchBankWallets, fetchUserWallets } from "./FetchData";
import { updateCryptoWallets } from "../store/actions/cryptoWalletsAction";
import { updateBankWallets } from "../store/actions/bankWalletsAction";

const WalletRoute = ({ children }) => {
  const dispatch = useDispatch();
  const id = useSelector((state) => state.user.id);
  const isCryptoWallets = useSelector( // get crypto wallets from store
    (state) => state.cryptoWallets.isCryptoWallets
  );

  const isBankWallets = useSelector( // get bank wallets from store
    (state) => state.bankWallets.isBankWallets
  );
  const [isWalletChecked, setIsWalletChecked] = useState(false);

  useEffect(() => { // check wallets
    if (!isCryptoWallets || !isBankWallets) {
        fetchUserWallets(id).then((data) => {
            fetchCryptoWallets(data.crypto).then((data) => {
                console.log(data, "c fetchUserWallets")
                updateCryptoWallets(dispatch, data);
            });
            fetchBankWallets(data.banks).then((data) => {
                console.log(data, "b fetchUserWallets")
                updateBankWallets(dispatch, data);
            });});
       
    } else { // if crypto wallets and bank wallets exist, set isWalletChecked to true
      setIsWalletChecked(true);
    }
  }, [isCryptoWallets, isBankWallets, dispatch, id]);

  if (!isWalletChecked) { // if wallets do not exist, check wallets
    return null;
  }

  return children;
};

export default WalletRoute;
